// eslint-disable-next-line no-undef
__webpack_public_path__ = evoAppsDistPath; //required when using require.ensure([])

// has to synchronously load first, to ensure polyfills installed on runtime for all modules
require('@babel/polyfill');

// IE fix no console when dev tools are closed
const noop = () => undefined;
if (!console) console = {
	log: noop,
	warn: noop,
	error: noop,
};
if (typeof console.log !== 'function') console.log = noop;
if (typeof console.warn !== 'function') console.warn = noop;
if (typeof console.error !== 'function') console.error = noop;